<form [formGroup]="fixedDepositProductDetailsForm">
  <div class="layout-row-wrap gap-2px responsive-column">
    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Product Name' | translate }}</mat-label>
      <input matInput formControlName="name" required />
      @if (fixedDepositProductDetailsForm.controls.name.hasError('required')) {
        <mat-error>
          {{ 'labels.inputs.Product Name' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="flex-48">
      <mat-label>{{ 'labels.inputs.Short Name' | translate }}</mat-label>
      <input matInput formControlName="shortName" maxlength="4" required />
      @if (fixedDepositProductDetailsForm.controls.shortName.hasError('required')) {
        <mat-error>
          {{ 'labels.inputs.Short Name' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="flex-98">
      <mat-label>{{ 'labels.inputs.Description' | translate }}</mat-label>
      <textarea matInput formControlName="description" required></textarea>
      @if (fixedDepositProductDetailsForm.controls.description.hasError('required')) {
        <mat-error>
          {{ 'labels.inputs.Description' | translate }} {{ 'labels.commons.is' | translate }}
          <strong>{{ 'labels.commons.required' | translate }}</strong>
        </mat-error>
      }
    </mat-form-field>
  </div>

  <div class="layout-row align-center gap-2percent margin-t responsive-column">
    <button mat-raised-button matStepperPrevious disabled>
      <fa-icon icon="arrow-left" class="m-r-10"></fa-icon>
      {{ 'labels.buttons.Previous' | translate }}
    </button>
    <button mat-raised-button matStepperNext>
      {{ 'labels.buttons.Next' | translate }}
      <fa-icon icon="arrow-right" class="m-l-10"></fa-icon>
    </button>
  </div>
</form>
